export default (value, ...attrs) => {
  if (typeof value === 'function') {
    return value(...attrs);
  }

  return value;
}
